/* eslint-disable import/prefer-default-export */
import prospectDomain from './prospect.domain';

export const domain = prospectDomain;
